import {UntilDestroy} from '@ngneat/until-destroy';
import {Component, forwardRef, OnInit} from '@angular/core';
import { NG_VALUE_ACCESSOR, Validators, FormGroup, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AbstractControlValueAccessor} from '../abstract-control-value-accessor';
import {Subscription} from 'rxjs';
import {distinctUntilChanged, tap} from 'rxjs/operators';
import {MARK, Mark} from '@portal-workspace/grow-ui-library/mark';
import {formControlErrorKeys, formControlErrorMessage, setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {compareMatch} from '@portal-workspace/grow-shared-library';
import {CoverType, InsurerSelectionValue, InsurerSelectionValueOptions} from '@portal-workspace/grow-shared-library';
import { MatOptionModule } from '@angular/material/core';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';


@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    selector: 'insurer-selection',
    templateUrl: './insurer-selection.component.html',
    styleUrls: ['./insurer-selection.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InsurerSelectionComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => InsurerSelectionComponent) },
    ],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule]
})
export class InsurerSelectionComponent extends AbstractControlValueAccessor<InsurerSelectionValue> implements OnInit,Mark {

  options = InsurerSelectionValueOptions;
  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;

  formGroup: FormGroup<{
    selection:FormControl<InsurerSelectionValue>;
  }>;
  formControl: FormControl<InsurerSelectionValue>;
  coverTypes: CoverType[] = [];

  subscriptions: Subscription[] = [];

  constructor(private formBuilder: FormBuilder) {
    super();
    this.formControl = formBuilder.control(null, [Validators.required]);
    this.formGroup = formBuilder.group({
      selection: this.formControl,
    });
    const sub = this.formControl.valueChanges.pipe(
      distinctUntilChanged(compareMatch),
      tap((r: InsurerSelectionValue) => {
        if (this.formControl.valid) {
          this.propagateChange(r);
        } else {
          this.propagateChange(null);
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);
  }


  ngOnInit(): void {
    setupUntilDestroy(this);
  }

  doWriteValue(v: InsurerSelectionValue | null | undefined): void | InsurerSelectionValue {
    if (v) {
      const val = this.options.find(o => o === v);
      if (val) {
        this.formControl.setValue(val);
      }
    }
    return undefined;
  }
  mark() {
    this.formControl.markAllAsTouched();
    this.formControl.updateValueAndValidity();
  }


}
